'use strict';

const CoverView = require('balus/ui/view/body/diagram/cover');
const CoverTemplate = require('balus/ui/template/body/diagram-import/cover.hbs');

module.exports = CoverView.extend({
    template: CoverTemplate
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram-import/cover.js